import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=4a9c811a&scoped=true&"
var script = {}
import style0 from "./Submitted.vue?vue&type=style&index=0&id=4a9c811a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c811a",
  null
  
)

export default component.exports